import useShoppingBundleQuery from "~/clientState/hooks/useShoppingBundleQuery";

const useShoppingBundleIsPerksApplied = (): boolean => {
  const { data: shoppingBundleData } = useShoppingBundleQuery();

  return (
    shoppingBundleData?.getShoppingBundle?.membershipPerks?.perks?.some(
      (perk) => perk.isApplied,
    ) || false
  );
};

export default useShoppingBundleIsPerksApplied;
